import { render, staticRenderFns } from "./GenevaScore.vue?vue&type=template&id=a0430c78&scoped=true&"
import script from "./GenevaScore.vue?vue&type=script&lang=js&"
export * from "./GenevaScore.vue?vue&type=script&lang=js&"
import style0 from "./GenevaScore.vue?vue&type=style&index=0&id=a0430c78&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0430c78",
  null
  
)

export default component.exports